import styles from "./ActivityIndicator.module.css";
import ActivityIndicator from "./ActivityIndicator";
import FullscreenCard from "../containers/FullscreenCard";

const FullScreenActivityIndicator = ({ loading, text }) => {
  return (
    <>
      {loading && (
        <FullscreenCard>
          <div className={styles.indicatorDiv}>
            <ActivityIndicator text={text} loading={true} />
          </div>
        </FullscreenCard>
      )}
    </>
  );
};

export default FullScreenActivityIndicator;
